export { default } from './arrow-right-up'
